<template>
	<modal ref="modal">
		<template #title>Terms & Conditions</template>
		<template #body>
			<p>
				All membership plans automatically renew after the Free month/s promo
				included unless cancelled (Except cash payments).
			</p>
			<p>
				Credit card payments will auto-renew and auto-debit after your
				subcription expires
			</p>
			<p>
				I agree to the policy stipulated in this link
				<inertia-link href="/data-privacy-policy" class="fw-semibold">
					(www.trulyrichclub.com/data-privacy-policy)
				</inertia-link>
				and understand that the data collected from me are treated with
				strictest security and will be used in accordance to the creation of my
				membership profile in the Truly Rich Club as well as the sending of
				newsletters, updates and invites as part of my membership benefit.
			</p>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from '@vue/reactivity'

export default {
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
